export default "__VITE_ASSET__8278d702__"